import { defineStore } from 'pinia';
export const useTokenStore = defineStore('token', {
	state: () => {
		return {
			master_access_token: '',
			master_refresh_token: '',
			master_access_token_for_SNS_SignUp: '',
		};
	},
	getters: {
		isLogin(state) {
			return !!state.master_access_token;
		},
		getAccessToken(state) {
			return state.master_access_token;
		},
		getRefreshToken(state) {
			return state.master_refresh_token;
		},
		getAccessTokenForSNSSignUp(state) {
			return state.master_access_token_for_SNS_SignUp;
		},
	},
	actions: {
		setToken(accessToken: string, refreshToken: string) {
			this.master_access_token = accessToken;
			this.master_refresh_token = refreshToken;
		},
		setAccessToken(token: string) {
			this.master_access_token = token;
		},
		resetToken() {
			this.$reset();
		},
		setAccessTokenForSNSSignUp(token: string) {
			this.master_access_token_for_SNS_SignUp = token;
		},
	},
	persist: true,
});
